module.exports = __webpack_public_path__ + "img/Drivers_Economy_&_Population.e5ebe9e0.jpg";